<template>
  <div class="py-4 container-fluid mt-4">
    <div class="mt-4">
      <div class="tab-content">
        <div class="card mb-4">
          <div class="card-body pb-2">
            <form
              ref="form"
              action="#"
              method="post"
              role="form"
              v-on:submit.prevent="submit()"
            >
              <div class="row border-bottom">
                <!-- <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label class="form-label">Invoice</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Invoice"
                      v-model="purchase.invoice"
                    />
                  </div>
                </div> -->
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label class="form-label">Lokasi Cabang</label>
                    <select
                      class="form-select"
                      aria-label="Lokasi cabang"
                      v-model="purchase.location"
                    >
                      <option value="" selected>Pilih lokasi cabang</option>
                      <option
                        :value="location.id"
                        v-for="location in locations"
                        :key="location.id"
                      >
                        {{ location.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label class="form-label">Tanggal Transaksi</label>
                    <input
                      type="date"
                      class="form-control"
                      placeholder="Nama Produk"
                      v-model="purchase.date"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="form-group">
                    <label class="form-label">Admin</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Admin"
                      v-model="purchase.cashier"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-3 mt-3">
                  <label class="form-label mb-0">Tambah Produk</label>
                  <div class="row">
                    <div class="col-12 col-xs-3">
                      <div class="form-group">
                        <label class="form-label"
                          >Kode/Nama/Barcode Produk</label
                        >
                        <!-- <Select2 v-model="myValue" :options="myOptions" /> -->
                        <input
                          type="text"
                          class="form-control"
                          list="products"
                          id="exampleDataList"
                          placeholder="Type to search..."
                          autocomplete="off"
                          @input="
                            searchProduct();
                            selectProduct();
                          "
                          v-model="searchValue"
                        />
                        <datalist id="products">
                          <option
                            :value="
                              product.code +
                              ' | ' +
                              product.barcode +
                              ' | ' +
                              product.name
                            "
                            v-for="product in productOptions"
                            :key="product.id"
                          ></option>
                        </datalist>
                        <!-- <input
                          type="text"
                          class="form-control"
                          placeholder="Kode Produk"
                          v-model="searchValue"
                          @change="searchProduct()"
                        /> -->
                      </div>
                    </div>
                    <div class="col-12 col-xs-3">
                      <div class="form-group mb-1">
                        <label class="form-label">Kode Produk</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Kode Produk"
                          readonly
                          v-model="product.code"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xs-3">
                      <div class="form-group mb-1">
                        <label class="form-label">Nama Produk</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Nama Produk"
                          readonly
                          v-model="product.name"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xs-3">
                      <div class="form-group mb-1">
                        <label class="form-label">Harga</label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          placeholder="Harga"
                          v-model="product.price"
                          @input="calculateSubTotal()"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xs-3">
                      <div class="form-group">
                        <label class="form-label">Jumlah</label>
                        <input
                          type="number"
                          min="0"
                          class="form-control"
                          placeholder="Jumlah"
                          v-model="product.qty"
                          @input="calculateSubTotal()"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-xs-3">
                      <div class="form-group">
                        <label class="form-label">Total</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Total"
                          readonly
                          :value="formatNumber(product.total)"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <soft-button
                        color="info"
                        fullWidth
                        size="sm"
                        variant="outline"
                        type="button"
                        @click="addProduct()"
                      >
                        Tambahkan</soft-button
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-9 mt-3">
                  <label class="form-label mb-0">Daftar Produk</label>
                  <div class="table-responsive p-0">
                    <table
                      class="table align-items-center justify-content-center mb-0"
                    >
                      <thead>
                        <tr>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Kode Produk
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Nama Produk
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Harga
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Jumlah
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Total
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xs font-weight-bolder opacity-7"
                          >
                            Opsi
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="product in purchase.product_list"
                          :key="product.id"
                        >
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <h6 class="mb-0 text-xs">{{ product.code }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <h6 class="mb-0 text-xs">{{ product.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <input
                                  type="number"
                                  style="max-width: 200px"
                                  min="0"
                                  class="form-control"
                                  placeholder="Jumlah"
                                  v-model="product.price"
                                  @change="calculateTotal()"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <input
                                  type="number"
                                  style="max-width: 100px"
                                  min="0"
                                  class="form-control"
                                  placeholder="Jumlah"
                                  @change="calculateTotal()"
                                  v-model="product.qty"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <h6 class="mb-0 text-xs">
                                  {{ formatNumber(product.total) }}
                                </h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="d-flex px-2">
                              <div class="my-auto">
                                <h6 class="mb-0 text-sm">
                                  <a
                                    href="javascript:;"
                                    class="text-danger font-weight-bold text-xs"
                                    data-toggle="tooltip"
                                    data-original-title="Hapus Produk"
                                    @click="deleteProduct(product.id)"
                                    >Hapus</a
                                  >
                                </h6>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr style="background-color: #c0f3ff">
                          <td
                            colspan="3"
                            class="text-uppercase font-weight-bolder text-end"
                          >
                            Total
                          </td>
                          <td
                            class="text-uppercase font-weight-bolder text-center"
                          >
                            {{ purchase.qty }}
                          </td>
                          <td
                            class="text-uppercase font-weight-bolder text-center"
                          >
                            {{ formatNumber(purchase.total) }}
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row mt-4 py-3 border-top">
                <div class="col-12 d-flex justify-content-between">
                  <soft-button
                    type="button"
                    color="warning"
                    size="sm"
                    variant="outline"
                    @click="back()"
                  >
                    Batal
                  </soft-button>
                  <soft-button
                    color="success"
                    size="sm"
                    variant="outline"
                    :disable="disable"
                  >
                    <span
                      v-if="disable"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {{ disable ? " Loading..." : "Perbarui" }}
                  </soft-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
import axios from "axios";
import { sweatalert } from "@/reactivities/sweatalert.js";
import SoftButton from "@/components/SoftButton.vue";
// import Select2 from "vue3-select2-component";

export default {
  name: "edit-purchases",
  components: {
    SoftButton,
    // Select2,
  },
  data() {
    return {
      product: {
        id: null,
        code: null,
        name: null,
        qty: null,
        price: null,
        total: null,
      },
      products: [],
      productOptions: [],
      searchValue: "",
      purchase: {
        invoice: "",
        cashier: JSON.parse(localStorage.getItem("user")).name,
        date: new Date().toISOString().slice(0, 10),
        customer: "",
        product_list: [],
        location: "",
        total: 0,
        qty: 0,
      },
      locations: [],
      disable: false,
      myValue: "",
      myOptions: ["op1", "op2", "op3"],
      url: {
        urlSubmit: `${this.apiUrl}/purchase/${this.$route.params.id}`,
        urlGetPurchase: `${this.apiUrl}/purchase/${this.$route.params.id}`,
        urlGetProducts: `${this.apiUrl}/product`,
        urlGetLocation: `${this.apiUrl}/location`,
      },
      order: {
        column: 2,
        dir: "DESC",
      },
      lengthMenu: [10, 20, 40, 80, 160],
      pageLength: 10,
      authToken:
        "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken,
    };
  },
  mounted() {
    setTooltip();
    this.getDataProduct();
    this.getLocation();
  },
  methods: {
    getPurchase: function () {
      axios
        .get(this.url.urlGetPurchase, {
          headers: { Authorization: this.authToken },
        })
        .then((res) => {
          let purchase = res.data.data;
          this.purchase.invoice = purchase.invoice;
          this.purchase.cashier = purchase.cashier;
          this.purchase.date = purchase.date;
          this.purchase.customer = purchase.customer;
          this.purchase.location = purchase.location_id;

          purchase.details.forEach((product) => {
            let selectedProduct = this.products.find((item) => {
              return item.id == product.item_id;
            });

            this.purchase.product_list.push({
              id: selectedProduct.id,
              code: selectedProduct.code,
              name: selectedProduct.name,
              price: product.price,
              qty: product.quantity,
              discount: product.item_disc,
              total:
                (product.price - product.price * product.item_disc) *
                product.quantity,
            });
          });

          this.calculateTotal();
        })
        .catch((error) => {
          sweatalert.showAlert("error", error);
          this.$router.push({ name: "Pembelian" });
        });
    },
    back: function () {
      this.$router.push({ name: "Pembelian" });
    },
    submit: function () {
      this.disable = true;
      axios
        .put(this.url.urlSubmit, this.purchase, {
          headers: { Authorization: this.authToken },
        })
        .then((response) => {
          sweatalert.showAlert("success", response.data.message);
          this.$router.push({ name: "Pembelian" });
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          Object.keys(this.errors).forEach((key) => {
            sweatalert.showAlert("error", this.errors[key]);
          });
          this.disable = false;
        });
    },
    getDataProduct: function () {
      axios
        .get(this.url.urlGetProducts, {
          headers: { Authorization: this.authToken },
        })
        .then((res) => {
          this.products = res.data.data;

          this.getPurchase();
        })
        .catch((error) => {
          sweatalert.showAlert("error", error);
        });
    },
    getLocation: function () {
      axios
        .get(this.url.urlGetLocation, {
          headers: { Authorization: this.authToken },
        })
        .then((res) => {
          this.locations = res.data.data;
        })
        .catch((error) => {
          sweatalert.showAlert("error", error);
        });
    },
    searchProduct: function () {
      this.productOptions = [];
      const reg = new RegExp(this.searchValue);
      this.products.forEach((element) => {
        if (
          element.code.toLowerCase().match(reg) ||
          element.barcode.toLowerCase().match(reg) ||
          element.name.toLowerCase().match(reg)
        ) {
          this.productOptions.push(element);
        }
      });
    },
    selectProduct: function () {
      let product = this.products.find((item) => {
        return (
          item.code + " | " + item.barcode + " | " + item.name ===
          this.searchValue
        );
      });
      if (product) {
        this.product.id = product.id;
        this.product.code = product.code;
        this.product.name = product.name;
        this.product.qty = 1;
        this.searchValue = "";
      }
    },
    addProduct: function () {
      if (this.product.id) {
        let product = this.purchase.product_list.find((item) => {
          return item.id === this.product.id;
        });
        if (product)
          product.qty = parseFloat(product.qty) + parseFloat(this.product.qty);
        else
          this.purchase.product_list.push({
            id: this.product.id,
            code: this.product.code,
            name: this.product.name,
            price: this.product.price,
            qty: this.product.qty,
            discount: 0,
            total: this.product.total,
          });

        this.product.id = null;
        this.product.code = null;
        this.product.name = null;
        this.product.price = 0;
        this.product.qty = null;
        this.product.total = 0;

        this.calculateTotal();
      }
    },
    calculateSubTotal: function () {
      this.product.total = this.product.qty * this.product.price;
    },
    calculateTotal: function () {
      let total = 0;
      let qty = 0;
      this.purchase.product_list.forEach((element) => {
        element.total = parseFloat(element.qty) * element.price;
        total += element.total;
        qty += parseFloat(element.qty);
      });
      this.purchase.total = total;
      this.purchase.qty = qty;
    },
    deleteProduct: function (id) {
      this.purchase.product_list = this.purchase.product_list.filter(
        (product) => product.id !== id
      );
    },
    formatNumber: function (number) {
      if (number)
        return (
          "Rp" +
          parseFloat(number)
            .toFixed(2)
            .toString()
            .replace(".", ",")
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        );

      return "Rp0,00";
    },
  },
};
</script>
